import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import ThreeSphere from '../AMyteSphere/ThreeSphere';
import EquipmentRequestModal from './EquipmentRequestModal';

function EquipmentRequestPage() {
  const [modalOpen, setModalOpen] = useState(false);
  const [zoomMultiplier, setZoomMultiplier] = useState(5.5);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const navigate = useNavigate();

  // Set zoom multiplier based on screen size
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    setZoomMultiplier(isMobile ? 3 : 5.5);
  }, []);

  // Prevent background scrolling when any modal is open
  useEffect(() => {
    if (modalOpen || showSuccessPopup) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [modalOpen, showSuccessPopup]);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const handleSuccessSubmit = () => {
    setShowSuccessPopup(true);
    setModalOpen(false);
    setTimeout(() => {
      navigate('/joinMyte');
    }, 3000);
  };

  return (
   <div className="relative w-full h-screen overflow-hidden bg-black">
      <header className="w-full p-2 text-center relative z-10 bg-transparent">
        <img src="/LogoFile.png" alt="Myte Logo" className="max-w-[150px] mx-auto" />
      </header>
      <div className="relative w-full h-[calc(100%-60px)] z-0"> {/* Low z-index */}
        <ThreeSphere noAutoTransition zoomMultiplier={zoomMultiplier} />
        <div className="absolute top-0 left-0 w-full h-full z-10 flex flex-col justify-center items-center text-center p-2.5">
          <div className="mb-2.5">
            <h1 className="text-4xl text-white mb-0">Speak Your Equipment Needs</h1>
            <h2 className="text-2xl text-white mt-2.5">Let Your Voice Shape Your Tools</h2>
          </div>
          <button
            onClick={openModal}
            className="bg-gradient-to-r from-[#1F5683] to-[#246399] border-none rounded-md text-white py-3 px-6 text-base cursor-pointer hover:opacity-90"
          >
            New Equipment Request
          </button>
        </div>
      </div>
      <EquipmentRequestModal
        isOpen={modalOpen}
        closeModal={closeModal}
        onSuccessSubmit={handleSuccessSubmit}
      />
      {showSuccessPopup && (
        <Modal
          isOpen={true}
          style={{
            content: {
              width: '90%',
              maxWidth: '400px',
              maxHeight: '80vh',
              overflowY: 'auto',
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              transform: 'translate(-50%, -50%)',
              background: '#1e1e1e',
              color: '#fff',
              borderRadius: '8px',
              padding: '20px',
              textAlign: 'center',
            },
            overlay: {
              backgroundColor: 'rgba(0,0,0,0.8)',
              zIndex: 2000,
            },
          }}
          ariaHideApp={false}
        >
          <div className="mb-2.5">
            <img src="/LogoFile.png" alt="Myte Logo" className="max-w-[120px] mx-auto" />
          </div>
          <h2 className="text-2xl mb-2.5">Request Submitted Successfully!</h2>
          <p className="mb-2.5">Your equipment request has been submitted.</p>
          <p className="mb-2.5">You will be redirected shortly...</p>
          <button
            className="bg-[#2962ff] text-white py-2.5 px-5 border-none rounded-full cursor-pointer mt-2.5 hover:bg-[#1a4dff]"
            onClick={() => navigate('/joinMyte')}
          >
            Go Now
          </button>
        </Modal>
      )}
    </div>
  );
}

export default EquipmentRequestPage;